import React from 'react';
import styled from 'styled-components';
import { Outlet } from 'react-router-dom';
import { HEADER_HEIGHT } from 'utils/Utils';
import FunctionsList from './FunctionsList';
import { ThemeProvider as StyledThemeProvider } from 'styled-components';
import { useTheme } from '@material-ui/core/styles';

export const SharedUtilities: React.FC = () => {
  const theme = useTheme();
  return (
    <StyledThemeProvider theme={theme}>
      <FlexContainer>
        <FunctionsList />
        <RightMenu>
          <Outlet />
        </RightMenu>
      </FlexContainer>
    </StyledThemeProvider>
  );
};

const FlexContainer = styled.div`
  display: flex;
  flex-direction: row;
  height: calc(100vh - ${HEADER_HEIGHT}px);
`;

const RightMenu = styled.div`
  flex: 1;
  padding: 34px 51px 20px 51px;
  background-color: ${({ theme }) => theme.palette.background.paper};
  height: 100%;
  overflow-y: auto;
  padding-top: 0px;
`;
